/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.chevron-right\":[\"Pil til højre\"]}");